import React from "react";
import { FpCenter, FpContainer, FpLoader, InfoContents, InfoPayment } from "./PaymentPageLoaderStyles";

function PaymentPageLoader(props) {

  return (
    <FpContainer>
      <FpCenter>
        <InfoContents>
          <div>
            <FpLoader>
              <span />
              <span />
              <span />
            </FpLoader>
          </div>
          <InfoPayment>
            <h3>Processando pagamento</h3>
            <span>{props.value}</span>
            <br />
            
          </InfoPayment>
        </InfoContents>
      </FpCenter>
    </FpContainer>
  );
}

export default PaymentPageLoader;
